import { createTheme } from "@mui/material";

export const muiTheme = createTheme({
    palette: {
        primary: {
            main: '#B11116',
            light: '#d92c32',
            dark: '#8B0304',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#1E293B',
            light: '#334155',
            dark: '#0F172A',
            contrastText: '#ffffff',
        },
        info: {
            main: '#2563EB',
            light: '#60A5FA',
            dark: '#1D4ED8',
            contrastText: '#ffffff',
        },
        success: {
            main: '#059669',
            light: '#34D399',
            dark: '#047857',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#D97706',
            light: '#FBBF24',
            dark: '#B45309',
            contrastText: '#ffffff',
        },
        error: {
            main: '#DC2626',
            light: '#F87171',
            dark: '#B91C1C',
            contrastText: '#ffffff',
        },
        background: {
            default: '#F8FAFC',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#0F172A',
            secondary: '#475569',
            disabled: '#94A3B8',
        },
        divider: '#E2E8F0',
        white: {
            main: '#ffffff',
            darker: '#f8fafc',
            contrastText: '#0f172a',
        },
    },
    shape: {
        borderRadius: 10,
    },
    typography: {
        fontFamily: ['"Inter"', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
        h1: { fontWeight: 700, letterSpacing: '-0.025em', color: '#0F172A' },
        h2: { fontWeight: 700, letterSpacing: '-0.02em', color: '#0F172A' },
        h3: { fontWeight: 600, letterSpacing: '-0.015em', color: '#0F172A' },
        h4: { fontWeight: 600, letterSpacing: '-0.01em', color: '#0F172A' },
        h5: { fontWeight: 600, color: '#0F172A' },
        h6: { fontWeight: 600, color: '#0F172A' },
        subtitle1: { color: '#475569', fontWeight: 500 },
        subtitle2: { color: '#64748B', fontWeight: 500 },
        body1: { color: '#0F172A', lineHeight: 1.6 },
        body2: { color: '#475569', lineHeight: 1.55 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 600,
                    padding: '8px 18px',
                    boxShadow: 'none',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(177, 17, 22, 0.18)',
                        transform: 'translateY(-1px)',
                    },
                },
                containedPrimary: {
                    background: 'linear-gradient(135deg, #B11116 0%, #8B0304 100%)',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #c91a20 0%, #9e0f14 100%)',
                    },
                },
                outlined: {
                    borderColor: '#E2E8F0',
                    '&:hover': {
                        borderColor: '#B11116',
                        backgroundColor: 'rgba(177, 17, 22, 0.04)',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '14px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.05)',
                    transition: 'box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease',
                    backgroundColor: '#FFFFFF',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                },
                elevation1: {
                    boxShadow: '0 2px 4px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
                },
                elevation2: {
                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.06), 0 2px 4px -2px rgba(0,0,0,0.04)',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: '1px solid #F1F5F9',
                    padding: '12px 16px',
                    fontSize: '0.875rem',
                },
                head: {
                    backgroundColor: '#F8FAFC',
                    color: '#475569',
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    backgroundColor: '#FFFFFF',
                    '& fieldset': {
                        borderColor: '#CBD5E1',
                        transition: 'border-color 0.2s ease',
                    },
                    '&:hover fieldset': {
                        borderColor: '#94A3B8',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#B11116',
                        borderWidth: '2px',
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                },
            },
        },
    },
});